import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme, Typography } from '@material-ui/core'
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined'
import ConfirmationDialog from 'components/ConfirmationDialog/ConfirmationDialog'
import {
    ADD_PROJECT_MANUFACTURER_WARNING_TEXT,
    CANCEL_TEXT,
    CONTINUE_TEXT,
} from 'pages/components/constants'
import React, { useMemo } from 'react'
interface AddProjectWarningDialogProps {
    open: boolean
    onSubmit: () => void
    onCancel: () => void
}

const useStyles = makeStyles((theme: Theme) => ({
    dialogTitleContainer: {
        alignItems: 'center',
    },
    warningIcon: {
        fontSize: pxToRem(34),
        fill: '#F0451F',
    },
    titleText: {
        marginLeft: theme.spacing(1.5),
        color: '#304959',
        fontSize: pxToRem(34),
    },
    warningText: {
        color: '#3C3C3C',
        fontSize: pxToRem(14),
        fontWeight: 400,
        maxWidth: pxToRem(560),
        lineHeight: pxToRem(18),
        marginRight: pxToRem(8),
        whiteSpace: 'pre-line',
    },
}))

export const AddProjectWarningDialog = ({
    open,
    onSubmit,
    onCancel,
}: AddProjectWarningDialogProps) => {
    const classes = useStyles()

    const dialogHeading = useMemo(
        () => (
            <>
                <GridContainer
                    className={classes.dialogTitleContainer}
                    data-testid="cautionHeader"
                >
                    <ReportProblemOutlinedIcon
                        data-testid="warningIcon"
                        className={classes.warningIcon}
                    />
                    <Typography className={classes.titleText} component="span">
                        Caution
                    </Typography>
                </GridContainer>
            </>
        ),
        []
    )

    const mainContent = useMemo(
        () => (
            <Typography
                className={classes.warningText}
                component="div"
                data-testid="warningText"
            >
                {ADD_PROJECT_MANUFACTURER_WARNING_TEXT}
            </Typography>
        ),
        []
    )

    return (
        <ConfirmationDialog
            dialogHeading={dialogHeading}
            openDialog={open}
            handleDialogClose={onCancel}
            dialogActionCallback={onSubmit}
            contentNode={mainContent}
            contentOverflow
            size="default"
            cancelText={CANCEL_TEXT}
            confirmText={CONTINUE_TEXT}
            confirmMessage=" "
            variant="default"
            contentStyles={{
                padding: 0,
                borderTop: 'none',
                borderBottom: 'none',
                width: 'auto',
            }}
        />
    )
}

export default AddProjectWarningDialog
